import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/configureStore';
import { set_isDisplayed } from 'store/ducks/Reportings/reportingSlice';
import { BProps, ICTSystemForFunction } from 'store/ducks/Reportings/types';
import { columnsICTSystemsForFunctions } from 'constants/reportColumns';
import { article8Op } from 'store/ducks/DataManagement/Article8AndICTSystem';

const ICTSystemsByFunctions: React.FC<BProps> = ({ entityName }) => {
  const { is_displayed, date } = useSelector(
    (state: RootState) => state.reportings,
  );
  const [data, setData] = useState<ICTSystemForFunction[]>([]);
  const dispatch = useDispatch();

  function flattenICTSystems(systems: ICTSystemForFunction[]) {
    const rows: any[] = [];

    systems.forEach((sys) => {
      const risks = sys.ict_risks.length ? sys.ict_risks : [null];

      risks.forEach((risk) => {
        rows.push({
          ...sys,
          _risk: risk,
        });
      });
    });

    return rows;
  }

  const fetchData = async () => {
    dispatch(set_isDisplayed(false));

    if (!entityName) return;

    const entityIds = entityName.split(',').map((id) => id.trim());
    try {
      const fetched = await article8Op.fetchICTSystemsDetailsByFunctions(
        entityIds[0],
        date,
      );

      if (fetched?.data?.ict_systems) {
        const flat = flattenICTSystems(fetched.data.ict_systems);
        setData(flat);
      } else {
        setData([]);
      }
    } catch (e) {
      console.error('Error fetching ICT systems:', e);
      setData([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, [is_displayed, entityName]);

  return (
    <Table
      columns={columnsICTSystemsForFunctions}
      dataSource={data.map((item, idx) => ({ ...item, key: idx }))}
      scroll={{ x: 1000, y: 430 }}
    />
  );
};

export default ICTSystemsByFunctions;
